import { render } from "./OnboardingView.vue?vue&type=template&id=8c85151e&scoped=true"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"

import "./OnboardingView.vue?vue&type=style&index=0&id=8c85151e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c85151e"]])

export default __exports__